import { useEffect, useState, type ReactNode } from "react";
import { useAuth } from "@/hooks";
import { pilotAccess, pilotWarningStartsAt } from "@/lib/pilot-access";
import { PilotAccessContext } from "./pilot-access-context";

export function PilotAccessProvider({ children }: { children: ReactNode }) {
  const { user, refreshUser } = useAuth();
  const [clock, setClock] = useState(0);
  const [refreshError, setRefreshError] = useState<string | null>(null);
  useEffect(() => {
    const end = Date.parse(user?.pilot_until ?? "");
    const now = Date.now();
    const next = [pilotWarningStartsAt(user?.pilot_until, user?.timezone), end + 1].find((at) => at > now);
    if (next === undefined) return;
    const timer = window.setTimeout(() => setClock((tick) => tick + 1), Math.min(next - now, 2_147_483_647));
    return () => window.clearTimeout(timer);
  }, [user?.pilot_until, user?.timezone, clock]);
  const refresh = () => {
    setRefreshError(null);
    void refreshUser().catch(() => setRefreshError("Não foi possível atualizar o acesso. Tente novamente."));
  };
  return <PilotAccessContext.Provider value={{ ...pilotAccess(user), refresh, refreshError }}>{children}</PilotAccessContext.Provider>;
}
